<template>
  <div class="form-floating">
    <select class="form-select" v-model="selectedValue" :disabled="isDisabled" :aria-label="ariaLabel">
      <option v-for="item in items" v-bind:key="item.value" :value="item.value">
        {{ item.text }}
      </option>
    </select>
    <label>{{ label }}</label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ListItem from "../ts/listItem";

export default defineComponent({
  name: "SelectList",
  props: {
    items: {
      type: Object as () => Array<ListItem>,
      required: true
    },
    label: { type: String, required: true },
    ariaLabel : { type: String, required: false }
  },
  data: function() {
    return {
      selectedValue: 1,
      disabled: false
    };
  },
  computed: {
    isDisabled: function(): boolean {
      return this.disabled;
    }
  },
  methods: {
    setSelectedValue(value: string) {
      this.selectedValue = value;
    },
    setDisabledState(value: boolean) {
      this.disabled = value;
    },
    getSelectedValue() {
      return this.selectedValue;
    },
    changeValue: function(newValue) {
      this.selectedValue = newValue;
    }
  }
});
</script>
